import { apiInstance } from '@/api/instance';
import { type User } from '@/types/user';

export const meApi = {
  read: () => apiInstance.get<User>('me'),
};

export const meApiKeys = {
  read: ['me'],
};
